import type { AccordionBlock as AccordionBlockType } from '@/shared/types/blocks';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/shared/ui/accordion';
import { BlockRenderer } from '../BlockRenderer';

interface AccordionBlockProps extends Omit<AccordionBlockType, 'type' | 'id'> {
  onToolClick?: (toolId: string) => void;
  /** 연결된 YouTube 영상 ID */
  linkedVideoId?: string;
}

/**
 * AccordionBlock - 아코디언
 *
 * 접기/펼치기 가능한 콘텐츠 섹션들을 표시합니다.
 * YouTube 영상 연동 시 하위 블록에 linkedVideoId를 전달합니다.
 */
export function AccordionBlock({
  items,
  defaultOpen,
  onToolClick,
  linkedVideoId,
}: AccordionBlockProps) {
  return (
    <Accordion type="single" collapsible defaultValue={defaultOpen}>
      {items.map((item) => (
        <AccordionItem key={item.id} value={item.id} className="border-b border-[#d9dde0]">
          <AccordionTrigger className="py-6 px-2 text-lg font-bold [&>svg]:size-6">
            {item.trigger}
          </AccordionTrigger>
          <AccordionContent>
            <BlockRenderer
              blocks={item.content}
              onToolClick={onToolClick}
              linkedVideoId={linkedVideoId}
              className="gap-6"
            />
          </AccordionContent>
        </AccordionItem>
      ))}
    </Accordion>
  );
}
